import React from 'react'
import '../Component/aboutUS.css'
export default function AboutUS() {
  return (
    <div>
       <div class="card" id='about'>
        <h1 data-aos="fade-down">About Me<span id="line"></span></h1>
        <p data-aos="fade-up-right">Greetings! I am Waleed Ahmed, currently pursuing a Bachelor of Computer Science with an expected completion date in 2025. My expertise in React JS, Next.js, Node.js, and the MERN stack, along with proficiency in React Native, I excel in creating dynamic user experiences. Leveraging React JS and Next.js, I develop scalable web applications, utilizing server-side rendering and seamless backend integration. My proficiency in Node.js enables the creation of efficient server-side applications, while my MERN stack knowledge empowers full-fledged application development. Additionally, my skills in React Native allow for cross-platform mobile application development, catering to diverse user bases. I adapt to evolving technological demands, offering versatile solutions for impactful and innovative projects.</p> 
        <div className='grid'>
          <div className='usleft'>
            <ul>
              <li data-aos="fade-left"><span className='key'>Study:</span> Computer Science</li>
              <li data-aos="fade-right"><span className='key'>City:</span> Karachi, Pakistan</li>
              <li data-aos="fade-left"><span className='key'>Phone:</span> +92 3122602807</li>
            </ul>
          </div>
          <div className='usright'>
          <ul>
              <li data-aos="fade-right"><span className='key'>Birthday:</span> 06-Oct-2000</li>
              <li data-aos="fade-left"><span className='key'>Freelance:</span> Available</li>
              <li data-aos="fade-right"><span className='key'>Email:</span> waleed.techverk@gmail.com</li>
            </ul>
            </div>
        </div>
    </div>
    </div>
  )
}
